<template>
	<div class="panel panel-default">
		<div class="panel-heading" id="headingOne">
			<h4 class="panel-title">
				<a
					data-toggle="collapse"
					:data-parent="'#' + $parent.id"
					:href="'#' + id"
				>
					{{ title }}
				</a>
			</h4>
		</div>
		<div :id="id" class="panel-collapse collapse">
			<div class="panel-body">
				<slot />
			</div>
		</div>
	</div>
</template>
<script>
	import uid from 'js/uid';
	export default {
		name: 'panel',
		data() {
			return {
				id: null,
			};
		},
		props: ['title'],
		mounted() {
			this.id = uid();
		},
	};
</script>



// WEBPACK FOOTER //
// src/app-components/accordion/panel.vue